import { render } from "./QuickpayPaymentHeader.vue?vue&type=template&id=66952548&scoped=true"
import script from "./QuickpayPaymentHeader.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentHeader.vue?vue&type=script&lang=js"

import "./QuickpayPaymentHeader.vue?vue&type=style&index=0&id=66952548&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66952548"]])

export default __exports__